import React, { useState } from 'react';
import { COLORS } from '../utils/constants.js';

export default function Contacts({ contacts, setContacts, setSelectedContact, setActiveTab, addNotification, ai }) {
  const [form, setForm] = useState({ first_name: '', last_name: '', email: '', title: '', organization_name: '' });
  const formFields = [
    { key: 'first_name', label: 'First Name' },
    { key: 'last_name', label: 'Last Name' },
    { key: 'email', label: 'Email' },
    { key: 'title', label: 'Job Title' },
    { key: 'organization_name', label: 'Company' },
  ];

  const addContact = () => {
    if (!form.first_name && !form.email) { addNotification('Enter at least a name or email', 'error'); return; }
    setContacts((prev) => [...prev, { ...form, id: Date.now().toString(), created_at: new Date().toISOString() }]);
    setForm({ first_name: '', last_name: '', email: '', title: '', organization_name: '' });
    addNotification('Contact added!', 'success');
  };

  return (
    <div>
      <h2 style={{ fontSize: 22, fontWeight: 700, marginBottom: 4 }}><span style={{ color: COLORS.blue }}>◎</span> Contact Manager</h2>
      <p style={{ color: COLORS.textMuted, fontSize: 13, margin: '0 0 20px' }}>Manage contacts synced from Apollo</p>

      <div style={{ padding: 20, borderRadius: 12, background: COLORS.surface, border: `1px solid ${COLORS.border}`, marginBottom: 20 }}>
        <h3 style={{ margin: '0 0 14px', fontSize: 14, fontWeight: 600 }}>Add New Contact</h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 12 }}>
          {formFields.map((f) => (
            <div key={f.key}>
              <label style={{ display: 'block', fontSize: 11, fontWeight: 600, color: COLORS.textDim, marginBottom: 4, textTransform: 'uppercase', letterSpacing: 1 }}>{f.label}</label>
              <input value={form[f.key]} onChange={(e) => setForm((p) => ({ ...p, [f.key]: e.target.value }))} placeholder={f.label} style={{ width: '100%', padding: '10px 12px', borderRadius: 8, border: `1px solid ${COLORS.border}`, background: COLORS.surfaceAlt, color: COLORS.text, fontSize: 13 }} />
            </div>
          ))}
        </div>
        <button onClick={addContact} style={{ marginTop: 16, padding: '10px 24px', borderRadius: 8, border: 'none', background: `linear-gradient(135deg, ${COLORS.green}, ${COLORS.greenDim})`, color: '#fff', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>Add Contact</button>
      </div>

      <div style={{ borderRadius: 12, background: COLORS.surface, border: `1px solid ${COLORS.border}`, overflow: 'hidden' }}>
        <div style={{ padding: '12px 20px', borderBottom: `1px solid ${COLORS.border}` }}>
          <h3 style={{ margin: 0, fontSize: 14, fontWeight: 600 }}>Your Contacts ({contacts.length})</h3>
        </div>
        {contacts.length === 0 ? (
          <div style={{ padding: 40, textAlign: 'center' }}>
            <p style={{ fontSize: 36, margin: 0 }}>📇</p>
            <p style={{ color: COLORS.textMuted, fontSize: 13, margin: '12px 0 0' }}>No contacts yet. Add one above.</p>
          </div>
        ) : contacts.map((c, i) => (
          <div key={i} style={{ padding: '14px 20px', borderBottom: `1px solid ${COLORS.border}`, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <div style={{ width: 36, height: 36, borderRadius: '50%', background: `linear-gradient(135deg, ${COLORS.blue}44, ${COLORS.purple}44)`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, fontWeight: 700, color: COLORS.blue }}>{(c.first_name?.[0] || '?').toUpperCase()}</div>
              <div>
                <p style={{ margin: 0, fontSize: 14, fontWeight: 600 }}>{c.first_name} {c.last_name}</p>
                <p style={{ margin: '2px 0 0', fontSize: 12, color: COLORS.textMuted }}>{c.title || '—'} · {c.organization_name || '—'} · {c.email || 'no email'}</p>
              </div>
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <button onClick={() => { setSelectedContact(c); setActiveTab('ai-tools'); }} style={{ padding: '6px 12px', borderRadius: 6, border: `1px solid ${COLORS.purple}44`, background: 'transparent', color: COLORS.purple, fontSize: 11, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>AI Score</button>
              <button onClick={() => { setSelectedContact(c); ai.draftEmail(c); setActiveTab('ai-tools'); }} style={{ padding: '6px 12px', borderRadius: 6, border: `1px solid ${COLORS.accent}44`, background: 'transparent', color: COLORS.accent, fontSize: 11, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>Draft Email</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
